import { render, staticRenderFns } from "./LessonsDetail.vue?vue&type=template&id=27310a83&scoped=true&"
import script from "./LessonsDetail.vue?vue&type=script&lang=js&"
export * from "./LessonsDetail.vue?vue&type=script&lang=js&"
import style0 from "./LessonsDetail.vue?vue&type=style&index=0&id=27310a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27310a83",
  null
  
)

export default component.exports